import { Button } from "@material-ui/core";
import { isEnabled } from "app/services/featureStorageService";
import { closeFormDialog, openLoadedFormDialog } from "app/store/tools/formDialogSlice";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

/**
 * Generates a 24-character hex string compatible with MongoDB ObjectId. Used
 * client-side so that we have a stable identifier for an email provider entry
 * BEFORE the OAuth round-trip happens. The OAuth callback will upsert the
 * provider sub-document by this id.
 */
const generateObjectIdHex = () => {
	const arr = new Uint8Array(12);
	if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
		window.crypto.getRandomValues(arr);
	} else {
		for (let i = 0; i < arr.length; i++) arr[i] = Math.floor(Math.random() * 256);
	}
	return Array.from(arr)
		.map((b) => b.toString(16).padStart(2, "0"))
		.join("");
};

const CarrierEmailAuthTypeForm = ({ dataIds, setTitle, setSize }) => {
	useEffect(() => {
		setTitle?.(`Select Email Provider`);
		setSize?.("max-w-sm");
		// eslint-disable-next-line
	}, []);

	const dispatch = useDispatch();

	const gmailOauthEnabled = isEnabled("GMAIL_OAUTH");
	const officeOauthEnabled = isEnabled("OFFICE_OAUTH");

	const target = dataIds?.target === "provider" ? "provider" : "smtp";

	// Generate a synthetic provider id once per dialog when one isn't supplied,
	// so a freshly-created OAuth provider can be located in the callback.
	const providerId = useMemo(() => {
		if (target !== "provider") return null;
		if (dataIds?.providerId) return dataIds.providerId;
		return generateObjectIdHex();
	}, [target, dataIds?.providerId]);

	const buildOAuthUrl = (oauthType) => {
		const baseUrl = `${process.env.REACT_APP_HTTP_SERVER}/api/profile/carriers/${dataIds?.carrierId}/oauth/authorize`;
		const params = new URLSearchParams();
		params.set("token", localStorage.getItem("tokenSmarthop") ?? "");
		if (oauthType) params.set("type", oauthType);
		params.set("onboarding", String(dataIds?.onboarding ?? false));
		params.set("target", target);
		if (providerId) params.set("providerId", providerId);
		return `${baseUrl}?${params.toString()}`;
	};

	return (
		<div className="flex-1 p-10">
			<div className="flex flex-col w-full">
				{gmailOauthEnabled && (
					<Button
						onClick={() => {
							window.open(buildOAuthUrl("gmail"));
							dispatch(closeFormDialog());
						}}
						className="text-18 p-32 w-full"
					>
						Gmail
					</Button>
				)}
				{officeOauthEnabled && (
					<Button
						onClick={() => {
							window.open(buildOAuthUrl("office365"));
							dispatch(closeFormDialog());
						}}
						className="text-18 p-32 w-full"
					>
						Office 365
					</Button>
				)}
				<Button
					onClick={() => {
						dispatch(closeFormDialog());
						dispatch(
							openLoadedFormDialog({
								formId: target === "provider" ? "CARRIER_EMAIL_PROVIDER_FORM" : "CARRIER_BRANDING_MAIL_CONF_FORM",
								dataIds,
								mode: target === "provider" ? "CREATE" : "EDIT",
							})
						);
					}}
					className="text-18 p-32 w-full"
				>
					Other
				</Button>
			</div>
		</div>
	);
};

export default CarrierEmailAuthTypeForm;
